import React, { useState } from 'react';
import styled from 'styled-components';
import { Modal } from '@mui/material';
import { FormContainer, RowContainer, BaseLabel, RadioLabel } from '../../../styles/styleUtils';
import ActionButtons from '../components/ActionButtons';
import KitDetail from './comp/KitDetail';
import ProdutoDetail from './comp/ProdutoDetail';
import { opcaoHistorica, kitCorrespondeAoCadastro, componentesDoKitParaEstoque } from './catalogoKitsEstoque';

const RadioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
`;

const RadioButton = styled.input`
  margin-right: 5px;
`;

const NewProdutoForm = React.forwardRef((props, ref) => {
  const [formData, setFormData] = useState(
    props.formData || {
      tipo: 'kit',
      idFornecedor: '',
      fornecedor: '',
      descricao: '',
      valorCompra: 0,
      unidade: '',
      moduloFotovoltaico: '',
      quantidadeModulo: '',
      inversor: '',
      quantidadeInversor: '',
      estrutura: '',
      quantidadeEstrutura: '',
      caboVermelho: '',
      quantidadeCaboVermelho: '',
      caboPreto: '',
      quantidadeCaboPreto: '',
      disjuntor: '',
      quantidadeDisjuntor: '',
      fabricante: '',
    }
  );

  const [kitSelecionado, setKitSelecionado] = useState(() => opcaoHistorica(props.formData));
  const disableConfirm = !formData.idFornecedor || !formData.descricao?.trim()
    || (formData.tipo === 'kit' && !kitCorrespondeAoCadastro(kitSelecionado, formData));

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((previous) => ({
      ...previous,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleAutoCompleteChange = (idName, name, value) => {
    const trocaFornecedor = name === 'fornecedor' && value?._id !== formData.idFornecedor;
    if (trocaFornecedor) setKitSelecionado(null);
    setFormData((previous) => ({
      ...previous,
      [idName]: value?._id || '',
      [name]: value,
      ...(trocaFornecedor && previous.tipo === 'kit'
        ? { descricao: '', ...componentesDoKitParaEstoque(null) } : {}),
    }));
  };

  const handleKitChange = (kit) => {
    setKitSelecionado(kit);
    setFormData((previous) => ({
      ...previous,
      descricao: kit?.nome || '',
      ...(kit?.historico ? {} : componentesDoKitParaEstoque(kit)),
    }));
  };

  const handleConfirm = () => {
    if (disableConfirm) return;
    props.onConfirm(formData);
  };

  const handleCancel = () => {
    if (window.confirm('Tem certeza que deseja cancelar?')) {
      props.handleClose();
    }
  };

  const handleTypeChange = (e) => {
    const tipo = e.target.value;
    setKitSelecionado(null);
    setFormData((previous) => ({
      ...previous, tipo, descricao: '', ...componentesDoKitParaEstoque(null),
    }));
  };

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <FormContainer>
        <RowContainer>
          <BaseLabel>Tipo</BaseLabel>
          <RadioButtonWrapper>
            <RadioButton
              type="radio"
              name="tipo"
              value="kit"
              checked={formData.tipo === 'kit'}
              onChange={handleTypeChange}
            />
            <RadioLabel>Kit</RadioLabel>
          </RadioButtonWrapper>
          <RadioButtonWrapper>
            <RadioButton
              type="radio"
              name="tipo"
              value="produto"
              checked={formData.tipo === 'produto'}
              onChange={handleTypeChange}
            />
            <RadioLabel>Produto</RadioLabel>
          </RadioButtonWrapper>
        </RowContainer>
        {formData.tipo === 'kit' && (
          <KitDetail
            formData={formData}
            kitSelecionado={kitSelecionado}
            onKitChange={handleKitChange}
            onAutoCompleteChange={handleAutoCompleteChange}
            onInputChange={handleInputChange}
          />
        )}
        {formData.tipo === 'produto' && (
          <ProdutoDetail
            formData={formData}
            onAutoCompleteChange={handleAutoCompleteChange}
            onInputChange={handleInputChange}
          />
        )}

        <ActionButtons onConfirm={handleConfirm} onCancel={handleCancel} disableConfirm={disableConfirm} />

      </FormContainer>
    </Modal>
  );
});

/*
AddProposta.propTypes = {
  produto: PropTypes.object,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onClose: PropTypes.func,
}
*/

export default NewProdutoForm;
